var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LazyYoutube',{ref:"youtubeLazyVideo",attrs:{"src":_vm.youtubeLink,"max-width":"720px","aspect-ratio":"4:3","thumbnail-quality":"standard","maxWidth":'100%'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }